<template>
  <Sidebar v-model:visible="visible" :header="header" position="right" @hide="onHide">
    <div v-if="assetForm">
      <AssetPropertiesForm :form="assetForm" @on-save="saveAsset"/>
    </div>
  </Sidebar>
</template>

<script>
import {useAssetsStore} from "@/stores/assets.js";
import {mapStores} from "pinia";
import AssetPropertiesForm from "@/Forms/Asset/AssetPropertiesForm.vue";

export default {
  name: "AssetSlideOver",
  components: {AssetPropertiesForm},
  data() {
    return {
      visible: false,
      asset: undefined,
      assetForm: undefined,
    }
  },
  computed: {
    ...mapStores(useAssetsStore),
    header() {
      return this.asset?.id
          ? this.$t('slide_overs.asset_slide_over.edit_asset')
          : this.$t('slide_overs.asset_slide_over.create_asset');
    },
  },
  methods: {
    async createAsset() {
      this.visible = true;
      this.assetForm = await this.assetsStore.createAsset();
    },
    async editAsset(asset) {
      if (!asset)
        return;

      this.asset = asset;
      this.visible = true;

      this.assetForm = await this.assetsStore.editAsset(asset.id);
    },
    async saveAsset() {
      try {
        await this.assetForm.submit();
        this.$emit('saved');
        this.visible = false;
      } catch (error) {
        //
      }
    },
    onHide() {
      this.asset = undefined;
      this.assetForm = undefined;
    },
  },
}
</script>